module.exports = __webpack_public_path__ + "media/images/sosial_media/ig-full-c-efd75721c6e85f0d688728dca6683fea.png";